<template>
    <div v-show="false">
        <img id="ai-img" :src="logoUrl">
        <canvas id="ai-canvas" class="logo-img" width="512" height="512"></canvas>
    </div>
</template>

<script>
export default {
    name: 'LogoBackgroundRemoval',
    props: {
        logoUrl: {
            type: String,
            default: () => ''
        },
        logoId: {
            type: Number,
            default: () => null
        },
        hyperparameters: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            imgsBGRemoved: [] // TODO remove
        }
    },
    mounted () {
        // console.log('logoBGRemoval mounted');
        this.$emit('canvasmounted', false);
    },
    beforeDestroy () {
        // console.log('logoBGRemoval before destroy');
    },
    methods: {
        processImage(logoId, removeBackground) {
            // console.log('processImage')
            const img = window.document.getElementById('ai-img')

            img.onload = () => this.imageOnload(logoId, img, removeBackground)
            
            if (this.imgsBGRemoved.includes(logoId)) {
                this.imgsBGRemoved = this.imgsBGRemoved.filter(item => item !== logoId)
            }

            img.src = window.Urls['logo_bot_request_get_logo_img'](logoId)

        },
        imageOnload(logoId, img, removeBackground) {
            console.log('imageOnload')
            if (!this.imgsBGRemoved.includes(logoId)) {
                this.imgsBGRemoved.push(logoId)
                const canvas = window.document.getElementById("ai-canvas")
                const context = canvas.getContext("2d")

                let hRatio = canvas.width / img.width
                let vRatio = canvas.height / img.height
                
                let ratioThreshold = this.hyperparameters.ratioThreshold
                if (typeof(this.hyperparameters.ratioThreshold) === 'string') { // TODO remove if implement buttons
                    ratioThreshold = parseFloat(this.hyperparameters.ratioThreshold)
                }
                
                let ratio = Math.min(hRatio, vRatio) + ratioThreshold

                let centerShift_x = (canvas.width - img.width * ratio) / 2
                let centerShift_y = (canvas.height - img.height * ratio) / 2

                context.clearRect(0, 0, canvas.width, canvas.height)

                if (removeBackground) context.filter = `blur(${this.hyperparameters.blurPixelRate}px)`
                else context.filter = `blur(${0}px)`

                context.drawImage(
                    img,
                    0, 0, img.width, img.height,
                    centerShift_x, centerShift_y, img.width * ratio, img.height * ratio
                )
                
                const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
                let pix = imageData.data
                
                if (this.hyperparameters.redDiff !== 0 || this.hyperparameters.blueDiff !== 0 || this.hyperparameters.greenDiff !== 0)
                    this.changeColors(pix)

                if (removeBackground) {
                    this.removeBackgroundColor(pix)
                    this.removeOutlierColors(pix)
                }

                context.putImageData(imageData, 0, 0)

                canvas.toBlob((blob) => {
                    this.$emit('blobLoaded', blob)
                }, 'image/png')
            }
        },
        removeBackgroundColor(pix) {
            console.log('removeBackgroundColor')
            let clusters = this.createColorClusters(pix, this.hyperparameters.kComponentsBackground)

            if (clusters.length > 0) {
                let biggestClusterIndex = this.getBiggestClusterIndex(clusters)
                            
                for (let i = 0; i < pix.length; i += 4) {
                    const r = pix[i]
                    const g = pix[i + 1]
                    const b = pix[i + 2]

                    let pixelDecColor = this.rgbToDecimal(r, g, b)

                    if (clusters[biggestClusterIndex].includes(pixelDecColor)) {
                        pix[i+3] = 0
                    }
                }
            }
        },
        removeOutlierColors(pix) {
            console.log('removeOutlierColors')
            let clusters = this.createColorClusters(pix, this.hyperparameters.kComponentsOutliers)

            if (clusters.length > 0) {
                let biggestClusterIndex = this.getBiggestClusterIndex(clusters)

                let std = this.calculateStandardDeviation(clusters[biggestClusterIndex])
                let cnt = this.calculateCentroid(clusters[biggestClusterIndex])

                for (let i = 0; i < pix.length; i += 4) {
                    const r = pix[i]
                    const g = pix[i + 1]
                    const b = pix[i + 2]

                    let pixelDecColor = this.rgbToDecimal(r, g, b)

                    if (Math.abs(pixelDecColor - cnt) > (this.std * std)) {
                        pix[i+3] = 0
                    }
                }
            }
        },
        changeColors(pix) {
            console.log('changeColors')
            for (let i = 0; i < pix.length; i += 4) {
                pix[i] = pix[i] + parseInt(this.hyperparameters.redDiff)
                pix[i + 2] = pix[i + 2] + parseInt(this.hyperparameters.blueDiff)
                pix[i + 1] = pix[i + 1] + parseInt(this.hyperparameters.greenDiff)
            }
        },
        createColorClusters(pix, kComponents) {
            console.log('createColorClusters')
            let decimalColorArray = []

            for (let i = 0; i < pix.length; i += 4) {
                const r = pix[i]
                const g = pix[i + 1]
                const b = pix[i + 2]
                const t = pix[i + 3]

                let decimalColor = this.rgbToDecimal(r, g, b)
                if (t > 0) {
                    decimalColorArray.push(decimalColor)
                }
            }

            // return this.kMeans(decimalColorArray, kComponents)

            console.log('decimalColorArray.length', decimalColorArray.length)

            const chunkSize = 100000
            const chunks = this.splitArray(decimalColorArray, chunkSize)
            const kMeans = []
            chunks.forEach(decimalColorArray => {
                kMeans.push(this.kMeans(decimalColorArray, kComponents))
            })
            console.log('full kMeans', kMeans.length)
            return this.mergeChunks(kMeans)
        },
        splitArray (array, chunkSize) {
            const result = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                result.push(array.slice(i, i + chunkSize));
            }
            return result;
        },
        mergeChunks(chunks) {
            return [].concat(...chunks);
        },
        getBiggestClusterIndex(clusters) {
            console.log('getBiggestClusterIndex')
            let i = 0
            let biggestClusterSize = clusters[0].length
            let biggestClusterIndex = 0

            clusters.forEach(c => {
                if (c.length > biggestClusterSize) {
                    biggestClusterSize = c.length
                    biggestClusterIndex = i
                }
                i++
            })

            return biggestClusterIndex
        },
        rgbToDecimal(r, g, b) {
            const decimalValue = (r << 16) + (g << 8) + b

            return decimalValue
        },
        kMeans(data, k) {
            const centroids = Array.from({ length: k }, () => Math.random() * (Math.max(...data) - Math.min(...data)) + Math.min(...data))

            const assignments = data.map(point => centroids.findIndex(centroid => Math.abs(point - centroid) === Math.min(...centroids.map(c => Math.abs(point - c)))))

            const clusters = Array.from({ length: k }, (_, i) => data.filter((_, j) => assignments[j] === i))

            return clusters
        },
        calculateCentroid(dataPoints) {
            console.log('calculateCentroid')
            if (dataPoints.length === 0) return null
            
            const sum = dataPoints.reduce((acc, val) => acc + val, 0)

            const centroid = sum / dataPoints.length

            return centroid
        },
        calculateStandardDeviation(arr) {
            console.log('calculateStandardDeviation')
            const mean = arr.reduce((acc, curr) => acc + curr, 0) / arr.length

            const squaredDifferences = arr.map((x) => Math.pow(x - mean, 2))

            const sumOfSquaredDifferences = squaredDifferences.reduce((acc, curr) => acc + curr, 0)

            const variance = sumOfSquaredDifferences / (arr.length - 1)

            const standardDeviation = Math.sqrt(variance)

            return standardDeviation
        }
    }
}
</script>